import toast from "react-hot-toast";
import TECH_SHEET_TYPES from "redux/types/techSheet";
import api from "services/api";
import errorHandler from "utils/errorHandler";

const createTechSheet = (techSheet, redirectOnSuccess) => {
  return (dispatch) => {
    let toastId = toast.loading(`Criando ficha técnica... `);
    api
      .put("tech_sheet", { ...techSheet, roleId: 1 })
      .then(() => {
        dispatch({
          type: TECH_SHEET_TYPES.CREATE_TECH_SHEET,
        });
        toast.success(`Ficha criado com sucesso. `);
        redirectOnSuccess("/menu/cadastro/ficha_tecnica");
      })
      .catch((err) => toast.error(errorHandler(err)))
      .finally(() => toast.dismiss(toastId));
  };
};

const updateTechSheet = (techSheet) => {
  return (dispatch) => {
    let toastId = toast.loading(`Atualizando ficha... `);
    api
      .put("tech_sheet", techSheet)
      .then((response) => {
        dispatch({
          type: TECH_SHEET_TYPES.UPDATE_TECH_SHEET,
        });
        toast.success(`Ficha atualizada com sucesso. `);
      })
      .catch((err) =>
        toast.error(`Erro ao atualizar ficha: ${errorHandler(err)}`)
      )
      .finally(() => toast.dismiss(toastId));
  };
};

const getTechSheet = (techSheetId) => {
  return (dispatch) => {
    let toastId = toast.loading(`Obtendo dados da ficha técnica... `);
    api
      .get(`tech_sheet/${techSheetId}`)
      .then((response) => {
        dispatch({
          type: TECH_SHEET_TYPES.GET_TECH_SHEET,
          techSheet: response.data,
        });
      })
      .catch((err) => toast.error(errorHandler(err)))
      .finally(() => toast.dismiss(toastId));
  };
};

const setHtmlStructure = (html) => {
  return (dispatch) => {
    dispatch({
      type: TECH_SHEET_TYPES.SET_HTML_STRUCTURE,
      payload: html,
    });
  };
};

const clearAll = () => {
  return (dispatch) => {
    dispatch({
      type: TECH_SHEET_TYPES.CLEAR,
    });
  };
};

export {
  createTechSheet,
  updateTechSheet,
  getTechSheet,
  setHtmlStructure,
  clearAll,
};
